import React from 'react';
import { useFormContext } from 'react-hook-form';
import cx from 'classnames';

import { hookFormFieldHoc, HookFormFieldCoreProps } from '../field.hoc';

import styles from './InputNumberCounterField.module.scss';

interface InputNumberCounterFieldProps extends HookFormFieldCoreProps {
  label: string;
  subLabel?: string;
  nlogAreaCode?: string;
}

const InputNumberCounterField: React.FC<InputNumberCounterFieldProps> = ({
  max: _max,
  min: _min,
  field,
  label,
  subLabel,
  className,
  name,
  valueAsNumber,
  nlogAreaCode,
}) => {
  const { setValue } = useFormContext();
  const currentValue = field?.value || 0;

  const max = typeof _max === 'object' ? _max.value : _max;
  const min = typeof _min === 'object' ? _min.value : _min;

  const handleClickDecrease = () => {
    if (max !== undefined && min === currentValue) {
      return;
    }
    setValue(name, currentValue - 1, { shouldValidate: true, shouldDirty: true });
  };

  const handleClickIncrease = () => {
    if (max !== undefined && max === currentValue) {
      return;
    }
    setValue(name, currentValue + 1, { shouldValidate: true, shouldDirty: true });
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (max && Number(e.target.value) > Number(max)) {
      e.target.value = String(max);
    }
    if (min && Number(e.target.value) < Number(min)) {
      e.target.value = String(min);
    }
    if (valueAsNumber) {
      e.target.value = Number(e.target.value).toString();
    }
    field?.onChange?.(e);
  };

  return (
    <label className={cx(styles.input_number_counter_field, className)}>
      <span className={styles.subject}>{label}</span>
      {subLabel && <i>{subLabel}</i>}
      <div className={styles.box}>
        <button
          className={styles.decrease}
          aria-label="줄이기"
          onClick={handleClickDecrease}
          type="button"
          {...(nlogAreaCode ? { 'data-event-nlog': 'click', 'data-event-area-code': `${nlogAreaCode}plus` } : {})}
        />
        <input type="number" {...field} value={field?.value ?? ''} max={max} min={min} onChange={handleChange} />
        <button
          className={styles.increase}
          aria-label="늘리기"
          onClick={handleClickIncrease}
          type="button"
          {...(nlogAreaCode ? { 'data-event-nlog': 'click', 'data-event-area-code': `${nlogAreaCode}minus` } : {})}
        />
      </div>
    </label>
  );
};

export default hookFormFieldHoc(InputNumberCounterField, { valueAsNumber: true });
